<script>
// PAGE:
import Layout from "@layouts/main";
import PageHeader from "@components/page-header";

export default {
  page: {
    title: "Home",
    meta: [{ name: "description", content: "Home" }],
  },
  components: { Layout },
  data() {
    return {
      title: "Home",
      breadCrumb: [
        {
          text: "Home",
          active: true,
        },
      ],
      loading: false,
      showDetail: false,
      scheduleDetail: null,
    };
  },
  mounted() {
    // this.fetchmyPortfolios()
  },
  watch: {},
  methods: {},
};
</script>

<template>
  <Layout> </Layout>
</template>

<style lang="scss">
.preloader.svg-animation {
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0px;
  left: 0px;
  right: 0px;
  z-index: 9999;
  margin: 0 auto;
  background-color: rgba(255, 255, 255, 0.55);
}
.fc .fc-button-primary {
  background-color: $primary-color-base;
}
</style>
